import type { Boost, Predicate, SearchDescriptor } from '@shared/core/search';

export interface TransportRequest<TDoc> {
  readonly descriptor: SearchDescriptor<TDoc>;
  readonly query: string;
  readonly filter: Predicate<TDoc>;
  readonly hitsPerPage: number;
  readonly boosts?: readonly Boost<TDoc>[];
  readonly signal?: AbortSignal;
}

export interface SearchTransport {
  search<TDoc>(request: TransportRequest<TDoc>): Promise<readonly TDoc[]>;
}

export class SearchAuthError extends Error {
  constructor(status: number) {
    super(`Search credentials rejected (${status})`);
    this.name = 'SearchAuthError';
  }
}

export const isAuthStatus = (status: number): boolean => status === 401 || status === 403;
